// extracted by mini-css-extract-plugin
export default {"cityChooser":"c-j_ee","cityChooser__text":"c-j_ef","cityChooser__placeholder":"c-j_eg","cityChooser__buttonIcon":"c-j_eh"};